import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Cancel = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      bgcolor="#fff5f5"
      px={3}
    >
      {/* <CancelOutlined sx={{ fontSize: 80, color: 'red' }} /> */}
      <Typography variant="h4" mt={2} fontWeight="bold">
        Payment Cancelled
      </Typography>
      <Typography variant="body1" mt={1} mb={3}>
        Your payment was not completed. Please try again or contact support.
      </Typography>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => navigate('/')}
      >
        Try Again
      </Button>
    </Box>
  );
};

export default Cancel;
